import { Link } from 'react-router-dom';
import { useVpsHostingHeroContent } from '../../../../hooks/useVpsHostingHeroContent';
import heroImage from '../../../../assets/images/vpshosting/hero/hero.png';
import './Hero.css';

const Hero = () => {
  const { content, isLoading } = useVpsHostingHeroContent();

  if (isLoading || !content) {
    return null;
  }

  const { eyebrow, title, text, cta, image } = content;

  return (
    <section className="vps-hosting-hero">
      <div className="vps-hosting-hero__inner">
        <div className="vps-hosting-hero__copy">
          {eyebrow ? <p className="vps-hosting-hero__eyebrow">{eyebrow}</p> : null}
          <h1 className="vps-hosting-hero__title">{title}</h1>
          {text ? <p className="vps-hosting-hero__text">{text}</p> : null}
          {cta?.text && cta?.url ? (
            <Link to={cta.url} className="vps-hosting-hero__cta luxury-btn">
              {cta.text}
            </Link>
          ) : null}
        </div>
      </div>

      <div className="vps-hosting-hero__media">
        <img
          className="vps-hosting-hero__image"
          src={image || heroImage}
          alt=""
          aria-hidden="true"
        />
      </div>
    </section>
  );
};

export default Hero;
